import { SelectedFeaturesTy } from '.';

export const parseFeatureValuesToString = (selectedFeatures: SelectedFeaturesTy) => {
    const result = []
    for (const key in selectedFeatures) {   
        for (const featureValue of selectedFeatures[key]) {
            result.push(featureValue)
        }
    }
    return result.join(';')
}